/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveSensorDataDto } from '../../models/live-sensor-data-dto';

export interface GetLiveSensorDataByHouse$Params {
  facilityGroupId: number;
  facilityId?: number;
}

export function getLiveSensorDataByHouse(http: HttpClient, rootUrl: string, params: GetLiveSensorDataByHouse$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LiveSensorDataDto>>> {
  const rb = new RequestBuilder(rootUrl, getLiveSensorDataByHouse.PATH, 'get');
  if (params) {
    rb.path('facilityGroupId', params.facilityGroupId, {});
    rb.query('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LiveSensorDataDto>>;
    })
  );
}

getLiveSensorDataByHouse.PATH = '/api/liveSensorData/facilityGroupId/{facilityGroupId}';
